import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_CSOB } from "../domain";
import { ACTION_GET_CURRENT_COMPANY_INFO } from "../GetCurrentCsobCompanyInfo";

import { csobHubApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_ACCEPT_CREDAC_CHANGE = "ACCEPT_CREDAC_CHANGE";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent];

const acceptCredacChange = async (): Promise<void> => {
  const response = await csobHubApi.csobHubControllerAcceptCredacCodeChange();

  return response.data;
};

export const useAcceptCredacChange = (
  user: UserProfileDto | null,
): {
  acceptCredacChange: UseMutateFunction<void, Error, void, unknown>;
  acceptCredacChangeAsync: () => Promise<void>;
  acceptCredacChangeEnabled: boolean;
  acceptCredacChangeError: Error | null;
  isPendingAcceptCredacChange: boolean;
  isSuccessAcceptCredacChange: boolean;
} => {
  const queryClient = useQueryClient();
  const enabled = roleGuard(user, allowedRoles);

  const { mutate, mutateAsync, isPending, isSuccess, error } = useMutation({
    mutationKey: [DOMAIN_CSOB, ACTION_ACCEPT_CREDAC_CHANGE],
    mutationFn: enabled ? acceptCredacChange : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_CSOB, ACTION_GET_CURRENT_COMPANY_INFO],
      });
    },
  });

  return {
    acceptCredacChange: mutate,
    acceptCredacChangeAsync: mutateAsync,
    acceptCredacChangeEnabled: enabled,
    acceptCredacChangeError: error,
    isPendingAcceptCredacChange: isPending,
    isSuccessAcceptCredacChange: isSuccess,
  };
};
